import React from 'react';

const AuthHeader = () => {
  // For Modal

  return (
    <>
      <header className="mainDashboard-main-header">

        Header
      </header>
    </>
  );
};

AuthHeader.propTypes = {

};

export default AuthHeader;
